import React from 'react';

// import LanguageSwitcher from '@/components/LanguageSwitcher';
import { Home } from '@/v2/pages/Home';

/**
 * 智能 Home 组件
 * 根据 i18next-browser-languagedetector 检测到的语言自动渲染对应版本
 * - 中文（zh、zh-CN）-> 渲染 HomeCN 组件
 * - 其他语言 -> 渲染 Home 组件
 */
export const SmartHome: React.FC = () => {
  return (
    <>
      {/* 开发环境下显示语言切换器 */}
      {/* {import.meta.env.DEV && <LanguageSwitcher />} */}

      {/* 根据语言渲染对应的 Home 组件 */}
      <Home />
    </>
  );
};

export default SmartHome;
